"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var src_exports = {};
__export(src_exports, {
  amber: () => import_amber2.amber,
  amberA: () => import_amberA2.amberA,
  amberDark: () => import_amber.amber,
  amberDarkA: () => import_amberA.amberA,
  blackA: () => import_blackA.blackA,
  blue: () => import_blue2.blue,
  blueA: () => import_blueA2.blueA,
  blueDark: () => import_blue.blue,
  blueDarkA: () => import_blueA.blueA,
  bronze: () => import_bronze2.bronze,
  bronzeA: () => import_bronzeA2.bronzeA,
  bronzeDark: () => import_bronze.bronze,
  bronzeDarkA: () => import_bronzeA.bronzeA,
  brown: () => import_brown2.brown,
  brownA: () => import_brownA2.brownA,
  brownDark: () => import_brown.brown,
  brownDarkA: () => import_brownA.brownA,
  crimson: () => import_crimson2.crimson,
  crimsonA: () => import_crimsonA2.crimsonA,
  crimsonDark: () => import_crimson.crimson,
  crimsonDarkA: () => import_crimsonA.crimsonA,
  cyan: () => import_cyan2.cyan,
  cyanA: () => import_cyanA2.cyanA,
  cyanDark: () => import_cyan.cyan,
  cyanDarkA: () => import_cyanA.cyanA,
  gold: () => import_gold2.gold,
  goldA: () => import_goldA2.goldA,
  goldDark: () => import_gold.gold,
  goldDarkA: () => import_goldA.goldA,
  grass: () => import_grass2.grass,
  grassA: () => import_grassA2.grassA,
  grassDark: () => import_grass.grass,
  grassDarkA: () => import_grassA.grassA,
  gray: () => import_gray2.gray,
  grayA: () => import_grayA2.grayA,
  grayDark: () => import_gray.gray,
  grayDarkA: () => import_grayA.grayA,
  green: () => import_green2.green,
  greenA: () => import_greenA2.greenA,
  greenDark: () => import_green.green,
  greenDarkA: () => import_greenA.greenA,
  indigo: () => import_indigo2.indigo,
  indigoA: () => import_indigoA2.indigoA,
  indigoDark: () => import_indigo.indigo,
  indigoDarkA: () => import_indigoA.indigoA,
  lime: () => import_lime2.lime,
  limeA: () => import_limeA2.limeA,
  limeDark: () => import_lime.lime,
  limeDarkA: () => import_limeA.limeA,
  mauve: () => import_mauve2.mauve,
  mauveA: () => import_mauveA2.mauveA,
  mauveDark: () => import_mauve.mauve,
  mauveDarkA: () => import_mauveA.mauveA,
  mint: () => import_mint2.mint,
  mintA: () => import_mintA2.mintA,
  mintDark: () => import_mint.mint,
  mintDarkA: () => import_mintA.mintA,
  olive: () => import_olive2.olive,
  oliveA: () => import_oliveA2.oliveA,
  oliveDark: () => import_olive.olive,
  oliveDarkA: () => import_oliveA.oliveA,
  orange: () => import_orange2.orange,
  orangeA: () => import_orangeA2.orangeA,
  orangeDark: () => import_orange.orange,
  orangeDarkA: () => import_orangeA.orangeA,
  pink: () => import_pink2.pink,
  pinkA: () => import_pinkA2.pinkA,
  pinkDark: () => import_pink.pink,
  pinkDarkA: () => import_pinkA.pinkA,
  plum: () => import_plum2.plum,
  plumA: () => import_plumA2.plumA,
  plumDark: () => import_plum.plum,
  plumDarkA: () => import_plumA.plumA,
  purple: () => import_purple2.purple,
  purpleA: () => import_purpleA2.purpleA,
  purpleDark: () => import_purple.purple,
  purpleDarkA: () => import_purpleA.purpleA,
  red: () => import_red2.red,
  redA: () => import_redA2.redA,
  redDark: () => import_red.red,
  redDarkA: () => import_redA.redA,
  sage: () => import_sage2.sage,
  sageA: () => import_sageA2.sageA,
  sageDark: () => import_sage.sage,
  sageDarkA: () => import_sageA.sageA,
  sand: () => import_sand2.sand,
  sandA: () => import_sandA2.sandA,
  sandDark: () => import_sand.sand,
  sandDarkA: () => import_sandA.sandA,
  sky: () => import_sky2.sky,
  skyA: () => import_skyA2.skyA,
  skyDark: () => import_sky.sky,
  skyDarkA: () => import_skyA.skyA,
  slate: () => import_slate2.slate,
  slateA: () => import_slateA2.slateA,
  slateDark: () => import_slate.slate,
  slateDarkA: () => import_slateA.slateA,
  teal: () => import_teal2.teal,
  tealA: () => import_tealA2.tealA,
  tealDark: () => import_teal.teal,
  tealDarkA: () => import_tealA.tealA,
  tomato: () => import_tomato2.tomato,
  tomatoA: () => import_tomatoA2.tomatoA,
  tomatoDark: () => import_tomato.tomato,
  tomatoDarkA: () => import_tomatoA.tomatoA,
  violet: () => import_violet2.violet,
  violetA: () => import_violetA2.violetA,
  violetDark: () => import_violet.violet,
  violetDarkA: () => import_violetA.violetA,
  whiteA: () => import_whiteA.whiteA,
  yellow: () => import_yellow2.yellow,
  yellowA: () => import_yellowA2.yellowA,
  yellowDark: () => import_yellow.yellow,
  yellowDarkA: () => import_yellowA.yellowA
});
module.exports = __toCommonJS(src_exports);
var import_amber = require("./dark/amber");
var import_blue = require("./dark/blue");
var import_bronze = require("./dark/bronze");
var import_brown = require("./dark/brown");
var import_crimson = require("./dark/crimson");
var import_cyan = require("./dark/cyan");
var import_gold = require("./dark/gold");
var import_grass = require("./dark/grass");
var import_gray = require("./dark/gray");
var import_green = require("./dark/green");
var import_indigo = require("./dark/indigo");
var import_lime = require("./dark/lime");
var import_mint = require("./dark/mint");
var import_olive = require("./dark/olive");
var import_orange = require("./dark/orange");
var import_pink = require("./dark/pink");
var import_plum = require("./dark/plum");
var import_purple = require("./dark/purple");
var import_mauve = require("./dark/mauve");
var import_red = require("./dark/red");
var import_sage = require("./dark/sage");
var import_sand = require("./dark/sand");
var import_sky = require("./dark/sky");
var import_slate = require("./dark/slate");
var import_teal = require("./dark/teal");
var import_tomato = require("./dark/tomato");
var import_violet = require("./dark/violet");
var import_yellow = require("./dark/yellow");
var import_amberA = require("./dark/amberA");
var import_blueA = require("./dark/blueA");
var import_bronzeA = require("./dark/bronzeA");
var import_brownA = require("./dark/brownA");
var import_crimsonA = require("./dark/crimsonA");
var import_cyanA = require("./dark/cyanA");
var import_goldA = require("./dark/goldA");
var import_grassA = require("./dark/grassA");
var import_grayA = require("./dark/grayA");
var import_greenA = require("./dark/greenA");
var import_indigoA = require("./dark/indigoA");
var import_limeA = require("./dark/limeA");
var import_mintA = require("./dark/mintA");
var import_oliveA = require("./dark/oliveA");
var import_orangeA = require("./dark/orangeA");
var import_pinkA = require("./dark/pinkA");
var import_plumA = require("./dark/plumA");
var import_purpleA = require("./dark/purpleA");
var import_mauveA = require("./dark/mauveA");
var import_redA = require("./dark/redA");
var import_sageA = require("./dark/sageA");
var import_sandA = require("./dark/sandA");
var import_skyA = require("./dark/skyA");
var import_slateA = require("./dark/slateA");
var import_tealA = require("./dark/tealA");
var import_tomatoA = require("./dark/tomatoA");
var import_violetA = require("./dark/violetA");
var import_yellowA = require("./dark/yellowA");
var import_amber2 = require("./light/amber");
var import_blue2 = require("./light/blue");
var import_bronze2 = require("./light/bronze");
var import_brown2 = require("./light/brown");
var import_crimson2 = require("./light/crimson");
var import_cyan2 = require("./light/cyan");
var import_gold2 = require("./light/gold");
var import_grass2 = require("./light/grass");
var import_gray2 = require("./light/gray");
var import_green2 = require("./light/green");
var import_indigo2 = require("./light/indigo");
var import_lime2 = require("./light/lime");
var import_mint2 = require("./light/mint");
var import_olive2 = require("./light/olive");
var import_orange2 = require("./light/orange");
var import_pink2 = require("./light/pink");
var import_plum2 = require("./light/plum");
var import_purple2 = require("./light/purple");
var import_mauve2 = require("./light/mauve");
var import_red2 = require("./light/red");
var import_sage2 = require("./light/sage");
var import_sand2 = require("./light/sand");
var import_sky2 = require("./light/sky");
var import_slate2 = require("./light/slate");
var import_teal2 = require("./light/teal");
var import_tomato2 = require("./light/tomato");
var import_violet2 = require("./light/violet");
var import_yellow2 = require("./light/yellow");
var import_amberA2 = require("./light/amberA");
var import_blueA2 = require("./light/blueA");
var import_bronzeA2 = require("./light/bronzeA");
var import_brownA2 = require("./light/brownA");
var import_crimsonA2 = require("./light/crimsonA");
var import_cyanA2 = require("./light/cyanA");
var import_goldA2 = require("./light/goldA");
var import_grassA2 = require("./light/grassA");
var import_grayA2 = require("./light/grayA");
var import_greenA2 = require("./light/greenA");
var import_indigoA2 = require("./light/indigoA");
var import_limeA2 = require("./light/limeA");
var import_mintA2 = require("./light/mintA");
var import_oliveA2 = require("./light/oliveA");
var import_orangeA2 = require("./light/orangeA");
var import_pinkA2 = require("./light/pinkA");
var import_plumA2 = require("./light/plumA");
var import_purpleA2 = require("./light/purpleA");
var import_mauveA2 = require("./light/mauveA");
var import_redA2 = require("./light/redA");
var import_sageA2 = require("./light/sageA");
var import_sandA2 = require("./light/sandA");
var import_skyA2 = require("./light/skyA");
var import_slateA2 = require("./light/slateA");
var import_tealA2 = require("./light/tealA");
var import_tomatoA2 = require("./light/tomatoA");
var import_violetA2 = require("./light/violetA");
var import_yellowA2 = require("./light/yellowA");
var import_blackA = require("./blackA");
var import_whiteA = require("./whiteA");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  amber,
  amberA,
  amberDark,
  amberDarkA,
  blackA,
  blue,
  blueA,
  blueDark,
  blueDarkA,
  bronze,
  bronzeA,
  bronzeDark,
  bronzeDarkA,
  brown,
  brownA,
  brownDark,
  brownDarkA,
  crimson,
  crimsonA,
  crimsonDark,
  crimsonDarkA,
  cyan,
  cyanA,
  cyanDark,
  cyanDarkA,
  gold,
  goldA,
  goldDark,
  goldDarkA,
  grass,
  grassA,
  grassDark,
  grassDarkA,
  gray,
  grayA,
  grayDark,
  grayDarkA,
  green,
  greenA,
  greenDark,
  greenDarkA,
  indigo,
  indigoA,
  indigoDark,
  indigoDarkA,
  lime,
  limeA,
  limeDark,
  limeDarkA,
  mauve,
  mauveA,
  mauveDark,
  mauveDarkA,
  mint,
  mintA,
  mintDark,
  mintDarkA,
  olive,
  oliveA,
  oliveDark,
  oliveDarkA,
  orange,
  orangeA,
  orangeDark,
  orangeDarkA,
  pink,
  pinkA,
  pinkDark,
  pinkDarkA,
  plum,
  plumA,
  plumDark,
  plumDarkA,
  purple,
  purpleA,
  purpleDark,
  purpleDarkA,
  red,
  redA,
  redDark,
  redDarkA,
  sage,
  sageA,
  sageDark,
  sageDarkA,
  sand,
  sandA,
  sandDark,
  sandDarkA,
  sky,
  skyA,
  skyDark,
  skyDarkA,
  slate,
  slateA,
  slateDark,
  slateDarkA,
  teal,
  tealA,
  tealDark,
  tealDarkA,
  tomato,
  tomatoA,
  tomatoDark,
  tomatoDarkA,
  violet,
  violetA,
  violetDark,
  violetDarkA,
  whiteA,
  yellow,
  yellowA,
  yellowDark,
  yellowDarkA
});
//# sourceMappingURL=index.js.map
